import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private url = environment.apiUrl;

  constructor(private http: HttpClient, private router: Router) { }

  isLoggedIn: boolean = false;


  logIn(userDetails: object) {
    return this.http.post<any>(this.url + '/v1/login', userDetails);
  }

  logOut() {
    const trackId = localStorage.getItem('trackId')
    this.http.post<any>(this.url + '/v1/logout', { trackId }).subscribe((resp: any) => {
      localStorage.clear();
      this.router.navigate(['/'])
    })
  }


  isAuthenticatedUser(): boolean {
    const token = localStorage.getItem('authToken');
    const expiration = localStorage.getItem('authTokenExpiration');
    return token && expiration && parseInt(expiration) > new Date().getTime();
  }

}
